import React, { useContext, createContext, useState } from "react";

const UserContext = createContext();

export const ProvideUserProps = ({ children }) => {
	const [loggedUser, _setLoggedUser] = useState(null);
	const [loggedCountry, setLoggedCountry] = useState(getCountryUserLocalStorage());

	const setLoggedUser = (user) => {
		_setLoggedUser(user);
		setLoggedCountry(user?.country);
		setCountryUserLocalStorage(user?.country);
	};

	const _loggedUserContext = {
		loggedUser,
		setLoggedUser,
		loggedCountry,
		setLoggedCountry,
	};

	return (
		<UserContext.Provider value={_loggedUserContext}>
			{children}
		</UserContext.Provider>
	);
};

export const useUserProps = () => useContext(UserContext);

const userCountryLocalStorageKey = "loggedCountry";

// setCountryUserLocalStorage(users: Array<Number> | null): void
export const setCountryUserLocalStorage = (loggedCountry) =>
	window.localStorage.setItem(
		userCountryLocalStorageKey,
		JSON.stringify(loggedCountry) || null
	);

// getCountryUserLocalStorage(): Array<Number> | null
export const getCountryUserLocalStorage = () =>
	JSON.parse(window.localStorage.getItem(userCountryLocalStorageKey));
